<template>
  <layouts-guest>
    <base-shadow-card :title="t('login.title')">
      <form @submit.prevent="onSubmit">
        <div class="mb-4">
          <label for="email" class="form-label">{{ t('word.email') }}</label>
          <input
            v-model="email"
            id="email"
            name="email"
            type="email"
            :placeholder="t('word.email')"
            :class="`form-input ${errors['email'] ? '!border-red-500' : ''}`"
          >
          <p class="form-error-text">{{ errors['email'] }}</p>
        </div>
        <div class="mb-4">
          <label for="password" class="form-label">{{ t('word.password') }}</label>
          <input
            v-model="password"
            id="password"
            name="password"
            type="password"
            :placeholder="t('word.password')"
            :class="`form-input ${errors['password'] ? '!border-red-500' : ''}`"
          >
          <p class="form-error-text">{{ errors['password'] }}</p>
        </div>
        <div class="mb-4">
          <label class="flex items-center">
            <div>
              <input type="checkbox" v-model="remember" />
            </div>
            <div class="ml-2 mb-1 text-sm">{{ t('login.save_login_status') }}</div>
          </label>
        </div>
        <div class="flex items-center justify-between pt-2">
          <base-form-submit :disabled="btnDisabled" :text="t('login.title')" />
          <router-link
            to="/forgot-password"
            class="text-link text-sm"
          >
            {{ t('forgot_password.title') }}
          </router-link>
        </div>
      </form>
    </base-shadow-card>
  </layouts-guest>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { axios } from '@/plugins/axios'
import { useRouter, useRoute } from 'vue-router'
import { HOME_PATH } from '@/router/routes'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { nextQueryKeys } from '@/router/queries'
import { RoleAttributes } from '@/types/models/role'

import LayoutsGuest from '@/layouts/Guest.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import Cookies from 'js-cookie'

export default defineComponent({
  components: { LayoutsGuest, BaseShadowCard, BaseFormSubmit },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const btnDisabled = ref(false)

    const schema = yup.object({
      email: yup.string().required().email().max(255),
      password: yup.string().required().max(255),
      remember: yup.boolean(),
    })
    const { handleSubmit, errors } = useForm({ validationSchema: schema })
    const { value: email } = useField<string>('email')
    const { value: password } = useField<string>('password')
    const { value: remember } = useField<boolean>('remember')

    const setCookieRole = (roles?: RoleAttributes) => {
      if (roles && Array.isArray(roles)) {
        roles.forEach(item => Cookies.set(item.slug, 'purchased', { domain: 'mentalnc.com' }))
      }
    }

    const onSubmit = handleSubmit(values => {
      const nextQuery = route.query[nextQueryKeys[0]] as string

      btnDisabled.value = true
      axios
        .post('/login', values)
        .then(response => {
          setCookieRole(response.data.payload.roles)

          const nextPath = nextQuery
          if (nextPath){
            if (route.query.wl){
              window.location.href = `${process.env.VUE_APP_WELL_LABO_URL}${route.query.next}`
            } else {
              router.push(nextPath)
            }
          } else {
            if (response.data.payload.display_mode === 'well_labo'){
              const is_well_labo = !!response.data.payload.roles.find((element:RoleAttributes) => element.slug === 'well_labo')
              if (is_well_labo){
                window.location.href = `${process.env.VUE_APP_WELL_LABO_URL}`
              } else {
                router.push(HOME_PATH)
              }
              
            } else {
              router.push(HOME_PATH)
            }
          }
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      password,
      remember,
      onSubmit,
      btnDisabled
    }
  },
})
</script>
